import {get, apiRoutes} from './../../api/api';

export const REQUEST_ELEMENT_VERSIONS = 'REQUEST_ELEMENT_VERSIONS';
export const RECEIVE_ELEMENT_VERSIONS = 'RECEIVE_ELEMENT_VERSIONS';
export const REQUEST_ELEMENT = 'REQUEST_ELEMENT';
export const RECEIVE_ELEMENT = 'RECEIVE_ELEMENT';

function requestElement(id) {
  return {
    type: REQUEST_ELEMENT,
    id: id
  };
}

function receiveElement(id, data) {
  return {
    type: RECEIVE_ELEMENT,
    item: data,
    id: id,
    receivedAt: Date.now()
  };
}

export function fetchElement(id) {
  return dispatch => {
    dispatch(requestElement(id));
    const url = apiRoutes.elements.get(id);
    return get(url, function (response) {
      dispatch(receiveElement(id, response.data));
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/elements/actions.js
 **/